import { Typography, Box } from '@mui/material';
import { Button } from 'design-system';
import { Link } from 'react-router';
import { getRoutePrefix } from 'services/theming';
import { useWhiteLabelling } from 'components/WhiteLabellingProvider';
import useUser from 'hooks/useUser';
import Register from 'images/Register';
import RegisterVilla from 'images/RegisterVilla';
import { FormType } from 'generated/graphql';

const CompleteRegistration = () => {
  const { user, onLogout } = useUser();
  const { isVillaProfile } = useWhiteLabelling();
  const prefix = getRoutePrefix();
  return (
    <Box
      sx={(theme) => ({
        textAlign: 'center',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        padding: theme.spacing(2),
        background: theme.palette.common.white,
        borderRadius: theme.spacing(1),
        margin: theme.spacing(10, 'auto', 0),
        maxWidth: 450,
        [theme.breakpoints.down('md')]: {
          minHeight: 'calc(100vh - 55px)',
        },
      })}
    >
      <Box component={isVillaProfile ? RegisterVilla : Register} sx={{ maxWidth: 200 }} />
      <Typography variant="h6" color="primary" sx={(theme) => ({ margin: theme.spacing(2, 0) })}>
        Complete your registration
      </Typography>
      <Typography color="textSecondary">
        Before you can start trading, we will need a few details from you. This helps us comply with legislation and
        make trading easier and more secure.
      </Typography>
      <Box
        sx={[
          {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
          },
          (theme) => ({ margin: theme.spacing(3, 0), gap: theme.spacing(1.5) }),
        ]}
      >
        <Button as={Link} to={`${prefix}/onboard`} variant="contained" color="secondary">
          Complete Profile
        </Button>
        {user?.multiProfile && (
          <Button as={Link} to={`${prefix}/profile/${user.profileId}/${FormType.ProfileSwitcher}`}>
            Switch between profiles
          </Button>
        )}
        <Button onClick={onLogout}>logout</Button>
      </Box>
    </Box>
  );
};

export default CompleteRegistration;
